import React from 'react';
import { createPortal } from 'react-dom';
import styled from '@xstyled/styled-components';
import { select } from '~/lib/select';
import { useTrainingStore } from '../state/useTrainingStore';
import { TrainingState } from '../state/TrainingState';
import { t } from 'ttag';

const Pill = styled.div`
  position: fixed;
  top: 20px;
  right: 70px;
  z-index: hud;
  background: ${p => p.theme.colors.overlayMed};
  padding: 0 10px;
  font-weight: bold;
  height: 35px;
  border-radius: 17.5px;
  color: white;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const selector = (s: TrainingState) =>
  select(
    s,
    'remainingDurationInMinutesForCourseTimers',
    'shouldDisplayTimeRemainingPill'
  );

const getHours = (time: number) => Math.floor(time / 60);
const getMinutes = (time: number) => time % 60;

export const TimeRemainingPill: React.FC = () => {
  const {
    remainingDurationInMinutesForCourseTimers: remainingDurationInMinutes,
    shouldDisplayTimeRemainingPill
  } = useTrainingStore(selector);

  if (!shouldDisplayTimeRemainingPill) return null;
  if (!remainingDurationInMinutes) return null;

  const hours = getHours(remainingDurationInMinutes);
  const minutes = getMinutes(remainingDurationInMinutes);

  return createPortal(
    <Pill
      className="timeRemainingPillStyleForDarkTheme"
      data-test-id="time-remaining-pill"
    >{t`Time remaining: ${hours}h ${minutes}m`}</Pill>,
    document.getElementById('root')!
  );
};
